var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Arrow - Left Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Left Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.4,
    d: "M15 27.5002C8.10625 27.5002 2.5 21.8927 2.5 15.0002C2.5 8.10774 8.10625 2.50024 15 2.50024C21.8925 2.50024 27.5 8.10774 27.5 15.0002C27.5 21.8927 21.8925 27.5002 15 27.5002Z",
    fill: "white",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7472 19.5352C20.9081 19.6962 20.9986 19.9145 20.9986 20.1422C20.9986 20.3698 20.9081 20.5881 20.7472 20.7491C20.5862 20.91 20.3679 21.0005 20.1403 21.0005C19.9126 21.0005 19.6943 20.91 19.5333 20.7491L15 16.2143L10.4652 20.7476C10.3043 20.9086 10.086 20.999 9.85831 20.999C9.63068 20.999 9.41236 20.9086 9.25139 20.7476C9.09043 20.5867 9 20.3684 9 20.1407C9 19.9131 9.09043 19.6948 9.25139 19.5338L13.7862 15.0005L9.25282 10.4657C9.09186 10.3047 9.00143 10.0864 9.00143 9.85878C9.00143 9.63115 9.09186 9.41283 9.25282 9.25186C9.41379 9.0909 9.6321 9.00047 9.85974 9.00047C10.0874 9.00047 10.3057 9.0909 10.4667 9.25186L15 13.7866L19.5348 9.25115C19.6957 9.09019 19.914 8.99976 20.1417 8.99976C20.3693 8.99976 20.5876 9.09019 20.7486 9.25115C20.9096 9.41212 21 9.63043 21 9.85807C21 10.0857 20.9096 10.304 20.7486 10.465L16.2138 15.0005L20.7472 19.5352Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon2);
export default __webpack_public_path__ + "static/media/close-icon-2.a75af7a2126d28c4b48fc740054402da.svg";
export { ForwardRef as ReactComponent };